import { Box, Button, Chip, Divider, Grid, Stack, Typography } from '@mui/material';
import { variants } from '../../../../variants/variants';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrent,
  selectCurrentKras,
  selectDesgination,
  selectDesiredKras,
  selectFullScreen,
  selectJuryDetails,
  selectPreview,
  selectRejectReason,
  selectShowMyHistory,
  setPreview,
  setShowHistory,
} from '../../giftSlice';
import { ArrowRightAltRounded, HistoryOutlined } from '@mui/icons-material';
import { useEffect, useRef, useState } from 'react';
import { empty } from '../../assets/index';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import GiftProgressBar from './GiftProgressBar';
import CandidatePreviewTools from '../Candidate/CandidatePreviewTools';
import ManagerPreviewTools from '../DeliveryHead/ManagerPreviewTools';
import RenderPreview from './RenderPreview';
import { useMediaQuery } from '@mui/material';

const components = {
  mygift: <CandidatePreviewTools />,
  submitted: <ManagerPreviewTools />,
};
const GiftPreview = ({ lg = 4, children, previewHeight = 'calc(100vh - 427px)' }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const value = pathname.split('/gift/')[1]?.split('/')[0];
  const myHistory = useSelector(selectShowMyHistory);
  const preview = useSelector(selectPreview);
  const currentkras = useSelector(selectCurrentKras);
  const desiredkras = useSelector(selectDesiredKras);
  const [show, setShow] = useState(1);
  const fullScreen = useSelector(selectFullScreen);
  const designations = useSelector(selectDesgination);
  const viewForm = Boolean(preview);
  const current = useSelector(selectCurrent);
  const reason = useSelector(selectRejectReason);
  const theme = useTheme();
  const jury = useSelector(selectJuryDetails);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
  const handleClick = val => {
    setShow(val);
  };

  useEffect(() => {
    if (current.designation === 'current') setShow(1);
    if (current.designation === 'desired') setShow(2);
  }, [current.designation]);
  return (
    <Grid
      item
      xs={12}
      md={lg}
      sx={{
        pl: 1,
        height: '100%',
        [theme.breakpoints.down('lg')]: {
          // display: !isPreview ? 'none' : 'grid',
          p: 0,
        },
      }}
    >
      <Stack
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: variants.boxRadius.MAIN,
          height: '100%',
          p: 1,
          [theme.breakpoints.down('lg')]: {
            border: 0,
            px: 0,
          },
        }}
      >
        <Stack
          sx={{
            [theme.breakpoints.down('lg')]: {
              display: 'none',
            },
          }}
        >
          <Typography
            sx={{
              py: 2,
              fontSize: variants.BODY,
              fontWeight: 600,
              textAlign: 'center',
            }}
          >
            GIFT Preview
          </Typography>

          <Divider />
        </Stack>
        {viewForm ? (
          <>
            <GiftProgressBar />
            {!fullScreen && designations.current && (
              <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
                mt={1}
                sx={{ display: { xs: 'flex', lg: 'flex' } }}
              >
                <Chip
                  label={designations.current.split(' - ')[0]}
                  variant='outlined'
                  onClick={() => handleClick(1)}
                  sx={{
                    background: show === 1 ? '#0A4FAC' : 'inherit',
                    color: show === 1 ? 'white' : 'inherit',
                  }}
                />
                <ArrowRightAltRounded fontSize='large' sx={{ color: '#0A4FAC' }} />
                <Chip
                  label={designations.desired.split(' - ')[0]}
                  variant='outlined'
                  onClick={() => handleClick(2)}
                  sx={{
                    background: show === 2 ? '#0A4FAC' : 'inherit',
                    color: show === 2 ? 'white' : 'inherit',
                  }}
                />
              </Stack>
            )}
            <div
              className='content'
              style={{
                flex: isMobile ? 1 : 0.85,
                border: '0px solid black',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  overflowY: 'auto',
                  display: 'flex',
                  border: 0,
                  height:
                    reason || jury
                      ? myHistory
                        ? '41vh'
                        : isMobile
                        ? 'calc(100vh - 360px)'
                        : previewHeight
                      : fullScreen
                      ? 'calc(100vh - 230px)'
                      : previewHeight,
                }}
              >
                {/* current designation kras */}
                <Box
                  sx={{
                    p: 1,
                    width: fullScreen ? 0.5 : 1,
                    display: fullScreen ? 'block' : show === 1 ? 'block' : 'none',
                  }}
                >
                  <RenderPreview completed={preview.current} kras={currentkras} label={'Current Designation'} />
                </Box>

                {/* desired designation kras */}
                <Box
                  sx={{
                    p: 1,
                    width: fullScreen ? 0.5 : 1,
                    display: fullScreen ? 'block' : show === 2 ? 'block' : 'none',
                  }}
                >
                  <RenderPreview completed={preview.desired} kras={desiredkras} label={'Desired Designation'} />
                </Box>
              </Box>
              {isMobile && children}
            </div>
            {!isMobile && children}

            {components[value]}
          </>
        ) : (
          <Stack alignItems={'center'} sx={{ p: 2, mt: 2 }}>
            <img style={{ width: '50%' }} src={empty} alt='pending' />
            <Typography sx={{ fontSize: variants.TINY, p: 1, color: 'rgba(0,0,0,0.7)' }}>
              No preview available!
            </Typography>
          </Stack>
        )}
      </Stack>
    </Grid>
  );
};

export default GiftPreview;
